<div class="login-page">
    <div class="login-shell">
        <section class="login-intro">
            <div class="intro-visual" aria-hidden="true">
                <span class="orb orb-1"></span>
                <span class="orb orb-2"></span>
                <span class="orb orb-3"></span>
                <div class="intro-badge">
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <span class="wave"></span>
                    <i class="fa fa-key"></i>
                </div>
            </div>
            <div class="intro-copy">
                <h2>Update your password</h2>
                <p>Your password has expired. Please set a new secure password to continue using Sovos.</p>
                <ul class="intro-points">
                    <li><i class="fa fa-shield"></i><span>Keep your account protected</span></li>
                    <li><i class="fa fa-key"></i><span>Use a strong, unique password</span></li>
                    <li><i class="fa fa-lock"></i><span>Never share your credentials</span></li>
                </ul>
            </div>
        </section>

        <section class="login-panel">
            <div class="login-brand">
                <img src="assets/images/sovos-logo-dark.png" alt="Sovos">
            </div>
            <form [formGroup]="changePasswordForm" class="login-form" autocomplete="off" (ngSubmit)="changePassword()">
                <h1 class="login-title">Change password</h1>
                <p class="login-subtitle">Enter your current and new password below.</p>

                <div class="login-field">
                    <label for="currentPassword">Current password</label>
                    <input type="password" class="login-input passdisc" formControlName="curentpassword"
                        id="currentPassword" placeholder="Current Password"
                        [ngClass]="{ 'errorBorder': isSubmitted && f.curentpassword.errors }"
                        autocomplete="current-password" autocorrect="off" autocapitalize="off" spellcheck="false">
                    <div *ngIf="isSubmitted && f.curentpassword.errors">
                        <span class="login-error" *ngIf="f.curentpassword.errors.required">Current Password Required</span>
                        <span class="login-error"
                            *ngIf="!f.curentpassword.errors.required && f.curentpassword.errors">Invalid Current Password</span>
                    </div>
                </div>

                <div class="login-field">
                    <label for="newPassword">New password</label>
                    <input type="password" class="login-input passdisc" formControlName="newpassword"
                        id="newPassword" placeholder="New Password"
                        [ngClass]="{ 'errorBorder': isSubmitted && f.newpassword.errors }"
                        autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false">
                    <div *ngIf="isSubmitted && f.newpassword.errors">
                        <span class="login-error" *ngIf="f.newpassword.errors.required">New Password Required</span>
                        <span class="login-error"
                            *ngIf="!f.newpassword.errors.required && f.newpassword.errors">Invalid New Password</span>
                    </div>
                </div>

                <div class="login-field">
                    <label for="confirmPassword">Confirm password</label>
                    <input type="password" class="login-input passdisc" formControlName="confirmpassword"
                        id="confirmPassword" placeholder="Confirm Password"
                        [ngClass]="{ 'errorBorder': isSubmitted && f.confirmpassword.errors }"
                        autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false">
                    <div *ngIf="isSubmitted && f.confirmpassword.errors">
                        <span class="login-error" *ngIf="f.confirmpassword.errors.required">Confirm Password Required</span>
                    </div>
                </div>

                <button type="submit" class="login-btn login-btn-primary login-btn-submit">SUBMIT</button>
            </form>
        </section>
    </div>
</div>
